import React from "react";

const Download = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.579"
      height="15.998"
      viewBox="0 0 17.579 15.998"
    >
      <script xmlns="" />
      <script xmlns="" />
      <g
        id="그룹_799"
        data-name="그룹 799"
        transform="translate(-1106.76 -4852.217)"
      >
        <path
          id="패스_1336"
          data-name="패스 1336"
          d="M-5540.54-2346.106v5.622h16.178v-5.622"
          transform="translate(6648 7208)"
          fill="none"
          stroke="current"
          strokeWidth="1.4"
        />
        <path
          id="패스_1337"
          data-name="패스 1337"
          d="M-5537.2-2349.5l4.585,4.214,4.615-4.214"
          transform="translate(6648 7208)"
          fill="none"
          stroke="current"
          strokeWidth="1.4"
        />
        <path
          id="패스_1338"
          data-name="패스 1338"
          d="M-5532.6-2355.783v10.684"
          transform="translate(6648 7208)"
          fill="none"
          stroke="current"
          strokeWidth="1.4"
        />
      </g>
    </svg>
  );
};

export default Download;
